import React from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Footer, Navbar } from "../../components";

const UserLayout = (props) => {
  AOS.init({
    easing: 'ease-out-back',
    duration: 1000,
    delay: 350,
    useClassNames: true,
    initClassName: false,
    animatedClassName: 'animated',
  });
  return (
    <div id='user'>
      <Navbar/>
      {props.content}
      <Footer />
    </div>
  );
}

export default UserLayout;